module.exports = __webpack_public_path__ + "img/list_item_one.a9a0ea07.png";